export default function random(max) {
  return (Math.floor(Math.random() * max) * 7) % max
}
